"use client";
import React, { useState } from "react";
import ReactDOM from "react-dom";
import Image from "next/image";
import { useRouter, useParams, useSearchParams } from "next/navigation";
import styles from "./SearchOverlay.module.css";
import { dictionaries, Locale } from "@/utils/i18n";

export default function SearchOverlay() {
  const [open, setOpen] = useState(false);
  const [searchTerms, setSearchTerms] = useState("");
  const router = useRouter();
  const params = useParams();
  const searchParams = useSearchParams();
  const locale = (params?.locale as string) || "vi";
  const dict = (dictionaries[locale as Locale] || dictionaries.vi).menu;

  const handleSearch = () => {
    if (!searchTerms.trim()) return;
    router.push(
      `/${locale}/san-pham/tim-kiem?keyword=${encodeURIComponent(searchTerms)}`
    );
    setOpen(false);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") handleSearch();
  };

  const overlayContent = (
    <div className={styles.overlay} onClick={() => setOpen(false)}>
      <button className={styles.closeBtn} onClick={() => setOpen(false)}>
        <span style={{ color: "white", fontSize: 22 }}>✕</span>
      </button>
      <div
        className={styles.contentWrapper}
        onClick={(e) => e.stopPropagation()}
      >
        <p className={styles.titleText}>Chúng tôi có thể giúp bạn tìm kiếm?</p>

        <div className={styles.searchBox}>
          <input
            type="text"
            className={styles.input}
            value={searchTerms}
            onChange={(e) => setSearchTerms(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder={
              typeof dict?.search === "string"
                ? dict.search
                : "Tìm kiếm sản phẩm..."
            }
            autoFocus
          />
          <button className={styles.iconBtn} onClick={handleSearch}>
            <Image
              src={`/icons/icon_search.svg`}
              alt="search"
              width={22}
              height={22}
            />
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <>
      {/* Nút mở search */}
      <button className={styles.searchBtn} onClick={() => setOpen(true)}>
        <div className={styles.searchIconWrapper}>
          <Image
            src={`/icons/icon_search.svg`}
            alt="search"
            fill
            style={{ objectFit: "contain" }}
          />
        </div>
      </button>

      {/* Render overlay qua Portal */}
      {open &&
        typeof window !== "undefined" &&
        ReactDOM.createPortal(overlayContent, document.body)}
    </>
  );
}
